import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { BaseServices } from './../../kuba.services';
import {
  ApprovalPerson,
  Employees,
  Project,
  Timetable,
  TypeOfWork,
} from './../models/timetable';
import { TimetableServices } from './timetable.service';

@Injectable()
export class TimeTableListResolver {
  constructor(private backend: TimetableServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<Timetable[]> {
    return this.backend.getAllByEach(
      +route.params['Id'],
      route.parent.parent.data['parent']
    );
  }
}

@Injectable()
export class TimeTableEditResolver {
  constructor(private backend: TimetableServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getById(+route.params['tid']);
  }
}

@Injectable()
export class EmployeeDropdownResolver {
  constructor(private backend: TimetableServices) {}

  resolve(route: ActivatedRouteSnapshot) {
    if (BaseServices.roleId === '2') {
      return null;
    }
    return this.backend.getEmpByBusinessId(BaseServices.BusinessId);
  }
}
@Injectable()
export class TypeOfWorkDropdownResolver {
  constructor(private backend: TimetableServices) {}

  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getTypeofworkbyBusinessId(BaseServices.BusinessId);
  }
}
@Injectable()
export class ApprovalPersonDropdownResolver {
  constructor(private backend: TimetableServices) {}

  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getallApprovalPerson();
  }
}

@Injectable()
export class EmployeeContactUserResolver {
  constructor(private backend: TimetableServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    if (BaseServices.roleId === '2') {
      return null;
    }
    return this.backend.getEmployeeContactUser();
  }
}
@Injectable()
export class ProjectDropdownResolver {
  constructor(private backend: TimetableServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getProByBusinessId(BaseServices.BusinessId);
  }
}
